import { ApiError, NetworkError } from "./api/client";

/**
 * Turns whatever was thrown into copy a contractor can act on.
 *
 * Deliberately NOT in the shared UI layer: what an `ApiError` means — that the
 * account is still under review, that payouts are not set up yet — is this
 * product's domain knowledge, not a design decision. The shared `ErrorState`
 * takes the finished sentence.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof NetworkError) return error.message;
  if (error instanceof ApiError) {
    if (error.isUnverified) {
      return "Your account is still being reviewed. You'll be able to work once it's verified.";
    }
    if (error.isBlocked) {
      return "Your account is on hold for new work. Contact support to resolve this.";
    }
    if (error.needsPayoutSetup) {
      return "Add your bank details before you can quote or accept work.";
    }
    if (error.code === "HOLD_CHECK_UNAVAILABLE") {
      return "We could not check this job's payment hold. Try again in a moment.";
    }
    if (error.status >= 500) return "Shoku had a problem at our end. Please try again.";
    return error.message;
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong.";
}
